export default __webpack_public_path__ + "static/media/VP Logo.296977ce.jpg";